import { API } from '../config/AppConfig';
import {
  AUDIT_UPLOADS,
  GET_SPECIALTIES,
  GET_ALL_USER_API,
  DELETE_UPLOADED_FILE,
  UPDATE_SUBMITTED_CHART,
  GET_SPECIALTIES_FOR_AUDITORS,
  SPLIT_AUDIT,
  AUTH_MANAGER_CLIENT_TOKEN,
  MY_CHARTS,
  GET_CLIENT_SPECIALTIES,
  CHART_UPDATE_V2,
  REVIEWERS,
} from '../constants/Endpoints';
import { ALL, ARCHIVED, NEW_UPLOAD, REBUTTAL } from '../constants/Filter';

class AuditRepository {
  constructor() {
    this.specialtyBasedAuditors = {};
  }

  async getAuditUploads(filterParams) {
    const response = await API.get(AUDIT_UPLOADS, {
      queryParams: {...filterParams, view: "MANAGER"},
    });
    return response;
  }

  async getAllAuditUploads(filterParams = {}) {
    filterParams = {
      ...filterParams,
      view: "MANAGER"
      // status: ALL
    };

    const response = await API.get(AUDIT_UPLOADS, {
      queryParams: filterParams,
    });
    return response;
  }

  async getNewUploads(filterParams = {}) {
    filterParams = {
      ...filterParams,
      status: NEW_UPLOAD,
      view: "MANAGER"
    };

    const response = await API.get(AUDIT_UPLOADS, {
      queryParams: filterParams,
    });
    return response;
  }

  async getArchivedUploads(filterParams = {}) {
    filterParams = {
      ...filterParams,
      status: ARCHIVED,
      view: "MANAGER"
    };

    const response = await API.get(AUDIT_UPLOADS, {
      queryParams: filterParams,
    });
    return response;
  }

  async getRebuttalUploads(filterParams = {}) {
    filterParams = {
      ...filterParams,
      status: REBUTTAL,
      view: "MANAGER"
    };

    const response = await API.get(AUDIT_UPLOADS, {
      queryParams: filterParams,
    });
    return response;
  }

  async getSpecialties() {
    const response = await API.get(GET_SPECIALTIES);
    return response;
  }

  async getUsers() {
    const response = await API.get(GET_ALL_USER_API);
    return response;
  }
  async updateSubmittedChart(id, params) {
    const response = await API.put(UPDATE_SUBMITTED_CHART, {
      formData: params,
      pathParams: { id },
    });
    return response;
  }

  async updateChart(id, data) {
    const response = await API.put(UPDATE_SUBMITTED_CHART, {
      ...data,
      pathParams: { id },
    });
    return response;
  }

  async deleteUploadedFile(uploadID) {
    const response = await API.delete(DELETE_UPLOADED_FILE, {
      pathParams: { uploadID },
    });
    return response;
  }

  async getAuditorList() {
    const specialties = await API.get(GET_SPECIALTIES_FOR_AUDITORS);
    for (let i = 0; i < specialties.length; i++) {
      const specialty = specialties[i];

      // specialty id -> auditor.id
      this.specialtyBasedAuditors[specialty.id] = specialty.auditors.sort((a, b) => {
                const firstComp = a.first_name.localeCompare(b.first_name);
                return firstComp !== 0 ? firstComp : a.last_name.localeCompare(b.last_name);
              });
    }

    return specialties;
  }

  async getReviewers(payload) {
    const response = await API.get(REVIEWERS, {
      queryParams: payload
    });
    return response;
  }

  async getAuditors(specialtyId) {
    return this.specialtyBasedAuditors[specialtyId] ?? [];
  }

  async createSplitAudit(uploadId, data) {
    const response = await API.post(SPLIT_AUDIT, {
      pathParams: { uploadId },
      body: data,
    });
    return response;
  }

  async auth_manager_client_token(client_id){
    const filterParams = {
      client_id: client_id,
    };
    const response = await API.get(AUTH_MANAGER_CLIENT_TOKEN, {
      queryParams: {...filterParams, view: "MANAGER"},
    });
    return response;
  }
  async getCharts(query) {
    const response = await API.get(MY_CHARTS, {
      queryParams: query,
    });
    return response;
  }

  async getClientSpecialties(queryParams) {
    const response = await API.get(GET_CLIENT_SPECIALTIES, {
      queryParams
    });
    return response
  }

  async updateChartsV2(payload) {
    const response = await API.patch(CHART_UPDATE_V2, {
      body: payload
    });
    return response;
  }  
}

const auditRepository = new AuditRepository();
export default auditRepository;
